import { SchedulesTable } from "@/components/schedules-table";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/schedules/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  return (
    <ScrollableContainer>
      <div className="h-max space-y-4 px-6 pt-5 pb-6">
        <MobilePageTitle>
          {t("pages:dashboard.sidebar.gym_schedules")}
        </MobilePageTitle>
        <SchedulesTable />
      </div>
    </ScrollableContainer>
  );
}
